import type { AxiosError } from 'axios'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step1Form } from '../../../containers/carkulka/Step1Form'
import { StepsContent } from '../../../context/StepsContext'
import { useSaveInsuranceParams, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'

export const Step1 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams, error, isLoadingData } = useContext(insuranceParamsContext)

  const { mutateAsync: updateStep } = useUpdateLastWizardStep()
  const { mutateAsync: saveInsuranceParams } = useSaveInsuranceParams()

  const handleSubmit = (values: InsuranceParamsDto) => {
    const promise = new Promise(function (resolve, reject) {
      saveInsuranceParams(values)
        .then((response) => {

          if (paramsId)
            refetchInsuranceParams()

          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 1) == 1)
              updateStep({ paramsId: Number(response?.data), step: 2, stepsStep: 'carkulka' }).then(() => refetchInsuranceParams())
            navigate(`/carkulka/wizard/2/${response?.data}`)
          } else {
            refetchInsuranceParams()
            navigate(`/carkulka/wizard/1/${response?.data}`)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          reject(err)
        })
        .finally(() => { })
    })

    return promise
  }

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={1} >
            <Steps icon="car" />

            <Step1Form onSubmit={handleSubmit} data={insuranceParams as InsuranceParamsDto} />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}